module.exports = __webpack_public_path__ + "media/ruoyi_03_是会转的星星.680b30c9.wav";